import * as fromUsuarioActions from './usuario.actions';

export const initialState: any = {
  usuario: {},
};

export function reducer(
  state = initialState,
  action: fromUsuarioActions.UsuarioActions
): any {
  switch (action.type) {
    case fromUsuarioActions.UsuarioActionTypes.USER_ALL:
      return state;
    case fromUsuarioActions.UsuarioActionTypes.USER_NEW:
      return (state = action.payload.user);
    default:
      return state;
  }
}
